import { useContext, useEffect, useState } from "react";
import { getSingleDocument } from '../firebase/utils'
import AdminContext from "../Helper/admin";

const useFetchUserRoles = (permissionKey, accessType) => {
  const [allow, setAllow] = useState(false)
  const { user } = useContext(AdminContext)

  const fetchData = async () => {
    // getSingleDocument(user.email)
    //   .then((data) => {
        if (user.isSuperAdmin) {
          setAllow(true)
          return
        }
        console.log(user.permissions)
        const isAllow = accessType(user.permissions, permissionKey);
        setAllow(isAllow)
      // })
  };

  useEffect(() => {
    fetchData();
  }, []);
  return allow

};

export default useFetchUserRoles;